import { EntTerritorialsUnits } from "../handBooks/territorialsUnits";
import { EntBasicHB } from "../handBooks/basicHB";
import { EntDirectoryInfoName } from "../directoryInfoName";
import { EntFiles } from "./storage";

export class EntLogisticsCenter {
  id: number|null = null;
  centerName: string|null = null;
  owner: string|null = null;
  description: string|null = null;
  commissioningYear: number|null = null;
  region?: EntTerritorialsUnits;
  area?: EntTerritorialsUnits;
  territorialUnit?: EntTerritorialsUnits;
  longitude: number|undefined = undefined;
  latitude: number|undefined = undefined;
  ownershipType?: EntDirectoryInfoName;
  registerStatus?: EntBasicHB;
  capacity?: EntLogisticsCenterCapacity[]|null = null;
  files?: EntFiles[];
  deletedFilesIds?: number[];

  regionId?: number;
  areaId?: number;
  territorialUnitId?: number;
  ownershipTypeId?: number;
  registerStatusId?: number;
}

export class EntLogisticsCenterCapacity {
  key: number|null = null;
  id: number|null = null;
  storageAreaM2: number|null = null;
  dailyThroughputTon: number|null = null;
  coldStorageVolumeM3: number|null = null;
  transportAccess?: EntBasicHB|null = null;
  certifications?: EntBasicHB|null = null;
  availableServices?: EntBasicHB|null = null;

  transportAccessIds?: number[]|null = null;
  certificationsIds?: number[]|null = null;
  availableServicesIds?: number[]|null = null;
}
